var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.312 42a3.94 3.94 0 0 0 3.938-3.938V3.937A3.94 3.94 0 0 0 22.312 0H3.937A3.94 3.94 0 0 0 0 3.937v34.125A3.94 3.94 0 0 0 3.937 42zm-.984-10.5H4.922a.987.987 0 0 1-.985-.984V4.922c0-.542.443-.985.985-.985h16.406c.541 0 .984.443.984.985v25.594a.987.987 0 0 1-.984.984m-8.203 7.875A2.62 2.62 0 0 1 10.5 36.75a2.62 2.62 0 0 1 2.625-2.625 2.62 2.62 0 0 1 2.625 2.625 2.62 2.62 0 0 1-2.625 2.625",
    clipRule: "evenodd"
  })));
};
export default SvgMobile;